import { Component, EventEmitter, OnDestroy, OnInit, Output, ChangeDetectionStrategy, signal } from '@angular/core'

const HITAAN_LUVUN_RAJA_MS = 10000

@Component({
  selector: 'app-ocr-luenta',
  templateUrl: './ocr-luenta.component.html',
  styleUrls: ['./ocr-luenta.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class OcrLuentaComponent implements OnInit, OnDestroy {
  @Output() keskeyta = new EventEmitter<void>()

  readonly kestaaPitkaan = signal(false)

  private _hidasAjastin: ReturnType<typeof setTimeout> | null = null

  ngOnInit() {
    this._hidasAjastin = setTimeout(() => {
      this.kestaaPitkaan.set(true)
    }, HITAAN_LUVUN_RAJA_MS)
  }

  ngOnDestroy() {
    if (this._hidasAjastin) {
      clearTimeout(this._hidasAjastin)
    }
  }
}
